export default {
  'border-b': {
    borderBottomWidth: 1,
  },
  'border-t': {
    borderTopWidth: 1,
  },
  'border-tb': {
    borderTopWidth: 1,
    borderBottomWidth: 1,
  },
  'border-gray': {
    borderTopColor: '#dcdcdc',
    borderBottomColor: '#dcdcdc',
  },
  'border-lightgray': {
    borderTopColor: '#f2f2f2',
    borderBottomColor: '#f2f2f2',
  },
  'rounded-xs': {
    borderRadius: 2,
  },
  'rounded-sm': {
    borderRadius: 4,
  },
  'rounded-md': {
    borderRadius: 6,
  },
  'rounded-lg': {
    borderRadius: 8,
  },
  'rounded-xl': {
    borderRadius: 12,
  },
  'rounded-2xl': {
    borderRadius: 16,
  },
  'rounded-3xl': {
    borderRadius: 24,
  },
  'rounded-4xl': {
    borderRadius: 32,
  },
  'rounded-none': {
    borderRadius: 0,
  },
  'rounded-full': {
    borderRadius: 'calc(infinity * 1px)',
  },
};
